// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3402":"2a3c891efed1d990","7460":"5a92cfc239d2f2b6"}[chunkId] + ".js";
};